"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnCallShiftDtoStipendPayoutOptionEnum = void 0;
exports.instanceOfOnCallShiftDto = instanceOfOnCallShiftDto;
exports.OnCallShiftDtoFromJSON = OnCallShiftDtoFromJSON;
exports.OnCallShiftDtoFromJSONTyped = OnCallShiftDtoFromJSONTyped;
exports.OnCallShiftDtoToJSON = OnCallShiftDtoToJSON;
exports.OnCallShiftDtoToJSONTyped = OnCallShiftDtoToJSONTyped;
/**
 * @export
 */
exports.OnCallShiftDtoStipendPayoutOptionEnum = {
    OnCallbackOnly: 'ON_CALLBACK_ONLY',
    Always: 'ALWAYS'
};
/**
 * Check if a given object implements the OnCallShiftDto interface.
 */
function instanceOfOnCallShiftDto(value) {
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('payRate' in value) || value['payRate'] === undefined)
        return false;
    if (!('stipendPayoutOption' in value) || value['stipendPayoutOption'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
function OnCallShiftDtoFromJSON(json) {
    return OnCallShiftDtoFromJSONTyped(json, false);
}
function OnCallShiftDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totalRate': json['totalRate'],
        'payRate': json['payRate'],
        'minutesWorked': json['minutesWorked'] == null ? undefined : json['minutesWorked'],
        'stipendPayoutOption': json['stipendPayoutOption'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function OnCallShiftDtoToJSON(json) {
    return OnCallShiftDtoToJSONTyped(json, false);
}
function OnCallShiftDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'totalRate': value['totalRate'],
        'payRate': value['payRate'],
        'minutesWorked': value['minutesWorked'],
        'stipendPayoutOption': value['stipendPayoutOption'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}
//# sourceMappingURL=OnCallShiftDto.js.map